import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { MAP_MODES } from '../../../../../lib/constants'
import styles from '../../HistoricalImagery.module.scss'

function InaccessibleData(props) {
  const { isRestricting3D } = props
  return (
    <div className={styles.inaccessibleContainer}>
      <p className={styles.inaccessibleContent}>
        {isRestricting3D ? (
          <>
            This feature is inaccessible while using the <span className={styles.activeContent}>3D</span> map. Please switch to <span>2D</span> to continue
            using this feature.
          </>
        ) : (
          <>
            This feature is inaccessible while using the <span className={styles.activeContent}>Topographic</span> basemap. Please switch to the{' '}
            <span>Satellite</span> or <span>Hybrid</span> basemap to continue using this feature.
          </>
        )}
      </p>
    </div>
  )
}

InaccessibleData.propTypes = {
  isRestricting3D: PropTypes.bool,
  isTopographic: PropTypes.bool,
  // functions
  handleItemClick: PropTypes.func
}

export default connect(model => {
  const { is3DRestricted } = model.historicalImagery
  const { mapMode } = model.map
  const isRestricting3D = mapMode === MAP_MODES.ThreeD && is3DRestricted
  return {
    isRestricting3D
  }
})(InaccessibleData)
